import { css } from "@emotion/css"
import { Notyf, NotyfEvent } from "notyf"
import type { INotyfOptions } from "notyf"
import "notyf/notyf.min.css"

const notyfOptions: Partial<INotyfOptions> = {
  duration: 0,
  position: {
    x: "left",
    y: "bottom",
  },
  ripple: false,
  dismissible: true,
  types: [
    {
      type: "info",
      background: "#3399FF",
      className: css`
        max-width: 100vw !important;
        .notyf__message {
          font-size: 14px;
          white-space: pre;
        }
      `,
    },
  ],
}

export let clearPrevNotification: (() => void) | undefined

const notify = (message: string) => {
  clearPrevNotification?.()
  const notyf = new Notyf(notyfOptions)

  const notification = notyf.open({
    type: "info",
    message,
  })

  const listener = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      clear()
    }
  }
  window.addEventListener("keydown", listener)

  const clear = () => {
    notyf.dismiss(notification)
    window.removeEventListener("keydown", listener)
    clearPrevNotification = undefined
  }
  notification.on(NotyfEvent.Dismiss, clear)

  clearPrevNotification = clear
}

export default notify
